import { isNil } from 'lodash';
import { useCallback } from 'react';
import { useWorkflowTemplateWithCardDefinition } from '@shared/scenes/workflows/hooks';
import { API } from '@shared/types/api';
import { getChannelCardDefinition } from './getChannelCardDefinition';
import { useCardDefinitions } from './useCardDefinitions';

export function useGetCardDefinition(
  channel?: API.ChannelFragment,
): (cardDefinitionId?: string) => API.CardDefinitionFragment | undefined {
  const workflowTemplateData = useWorkflowTemplateWithCardDefinition(channel?.workflowTemplateId);
  const virtualCardDefinition = workflowTemplateData.workflowTemplate?.cardDefinition;
  const { cardDefinitions } = useCardDefinitions(channel?.id);
  return useCallback(
    cardDefinitionId => {
      const channelCardDefinition = getChannelCardDefinition(cardDefinitions, cardDefinitionId);
      return isNil(channel?.workflowTemplateId) ? channelCardDefinition : virtualCardDefinition;
    },
    [cardDefinitions, channel?.workflowTemplateId, virtualCardDefinition],
  );
}
